import { request } from "@p81-common/shell-core-js/dist/redux/accountGet";
import { useResource } from "./useResource";

export function useAccount() {
  return useResource("accountGet", request);
}
